export default "__VITE_ASSET__Baj5KnUe__"